import React from "react";
import Preloader from "../helper/Preloader";

import HeaderOne from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
// import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
// import ShippingOne from "../components/ShippingOne";
import Shipping from "../components/ShippingTwo";
// import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";


const AccountPage = () => {



  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      {/* <ScrollToTop smooth color="#FA6400" /> */}

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOne category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Shipping"} />

      {/* Account */}
      <Shipping />

      {/* ShippingOne */}
      {/* <ShippingOne /> */}

      {/* FooterTwo */}
      {/* <FooterTwo /> */}

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default AccountPage;